import { GameTextUtil } from "@lib/js-slingo-fruttiboost-core/dist/game/utils/GameTextUtil";
import { GameBigWinProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameBigWinProperties";
import { Point } from "pixi.js";
export class BigWinLandscapeProperties extends GameBigWinProperties {
    constructor() {
        super();
        this.position.set(973, 512);
        const text = [this.title0Properties, this.title1Properties, this.title2Properties, this.title3Properties].map(x => x.text);
        text.forEach(x => {
            x.size = new Point(760, 400);
        });
        GameTextUtil.centerProperties(...text);
    }
}
//# sourceMappingURL=BigWinLandscapeProperties.js.map